import { render, staticRenderFns } from "./Quotas.vue?vue&type=template&id=6d5a6ae6&scoped=true&"
import script from "./Quotas.vue?vue&type=script&lang=ts&"
export * from "./Quotas.vue?vue&type=script&lang=ts&"
import style0 from "./Quotas.vue?vue&type=style&index=0&id=6d5a6ae6&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a6ae6",
  null
  
)

export default component.exports